import { Component } from '@angular/core';

import { SettingsPage } from '../settings/settings';
import { AboutPage } from '../about/about';
import { PatientsPage } from '../patients/patients';
import {ReportsPage } from '../reports/reports'


@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  tab1Root: any = PatientsPage;
  tab2Root: any = AboutPage;
  tab3Root: any = ReportsPage;
  tab4Root: any = SettingsPage;


  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts